<template>
    <div class="panel" style="width: 100%;">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词" clearable></el-input>
                </el-form-item>
                <el-form-item label="分类">
                    <el-select v-model="form.categoryId" clearable  placeholder="全部">
                        <el-option
                            v-for="item in categories"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否关联角色" v-if="attr.type == 2">
                    <el-select v-model="form.relation" clearable  placeholder="是否关联角色">
                        <el-option label="关联" value="true"></el-option>
                        <el-option label="未关联" value="false"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="edit({})">新增</el-button>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    label="预览">
                    <template slot-scope="scope">
                        <template v-if="scope.row.type!=4">
                        <el-image
                            style="width: 100px; height: 75px"
                            :src="scope.row.url"
                            :preview-src-list="[scope.row.url]"
                            fit="fill"></el-image>
                        </template>
                        <template v-else>
                            <div @mouseenter="playSound(scope.row)" @mouseleave="stopSound(scope.row)">
                                <i class="sound_icon el-icon-message-solid font24"
                                   ></i>
                                <audio :src="scope.row.url" preload="auto" :ref="`sound${scope.row.id}`"></audio>
                            </div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="sn"
                    min-width="180"
                    label="编号" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="name"
                    label="名称" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    label="所属分类" >
                    <template slot-scope="scope">
                        <tag-group :tags="scope.row.categoryArray"></tag-group>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120"
                    v-if="attr.type == 2"
                    label="是否关联角色" >
                    <template slot-scope="scope">
                        <!-- {{scope.row.relatedIds}} -->
                       <div class="fx-col fx-center" style="color:#69e93f" v-if="scope.row.relatedIds != null">
                              已关联
                        </div>
                        <div class="fx-col fx-center" style="color:#F56C6C"
                        v-if="scope.row.relatedIds == null">
                              未关联
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120"
                    label="标签">
                    <template slot-scope="scope">
                        <tag-group :tags="scope.row.tagArray"></tag-group>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="180"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-link type="primary" @click="editSprite(scope.row)" v-if="attr.type == 2 && scope.row.relatedIds == null"
                                 :underline="false" ><i class="iconfont icon-bianji"></i><b>生成角色</b></el-link>
                        <el-link type="primary" @click="edit(scope.row)"
                                 :underline="false" ><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                        <el-popconfirm @onConfirm="del(scope.row)"
                                       title="确认删除该素材吗？"
                        >
                            <el-link type="danger" slot="reference"
                                     :underline="false" ><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <EditDraw v-if="showEdit" @submit="loadData" :type="attr.type"
                  @close="showEdit=false" :item="editItem"></EditDraw>
        <EditSpriteDrawer v-if="showEditSprit" @submit="loadData"
                  @close="showEditSprit=false" :item="editSprit" :itemCostumes="editSpritCostumes"></EditSpriteDrawer>

    </div>
</template>

<style scoped>
.sound_icon {
    cursor: pointer;
}
</style>
<style>

</style>

<script>

    import EditDraw from './EditDrawer';
    import EditSpriteDrawer from "./EditSpriteDrawer";


    export default {
        components: {
            EditSpriteDrawer,
            EditDraw,
        },
        props: [
            "attr" // {type: 类型}
        ],
        data() {
            return {
                editItem: {},
                showEdit: false,

                editSprit: {},
                editSpritCostumes: {},
                showEditSprit: false,

                categories: [],
                form: {
                    keywords: "",
                    type: this.attr.type,
                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.pager.dataTotal = 0;//不加上造型搜索显示不对
                    this.loadData();
                },
                deep: true

            }
        },

        methods: {
            playSound(item) {
                this.$refs['sound'+item.id].play();
            },
            stopSound(item) {
                this.$refs['sound'+item.id].currentTime=0;
                this.$refs['sound'+item.id].pause();
            },
            edit(item) {
                if (this.attr.type == 1) {
                    this.editSprit= {...item};
                    this.showEditSprit = true;
                } else {
                    this.editItem = {...item};
                    this.showEdit = true;
                }

            },
            editSprite(item) {
                this.editSpritCostumes = {...item};
                this.showEditSprit = true;
            },

            del(item) {
                this.$ajaxGet("/material/del/" + item.id, (data) => {
                    this.$showSuccess("删除成功");
                    this.loadData();
                })
            },

            modifyEnable(item) {
            },

            loadData() {
                this.$ajaxPost("/material/listBySchool", {
                    form: this.form,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;

                    this.showEdit = false;
                    this.showEditSprit = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },

            loadCategories() {
                //分类上，造型和角色用一个分类
                this.$ajaxGet(`/materialCategory/list/${this.attr.type == 2 ? 1:this.attr.type}-true`, data => {
                    this.categories = data.result;
                })
            }

        },

        created() {
            this.loadData();
            this.loadCategories();
        }

    }
</script>
